import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RdsToastService } from '@rds/angular-components';
import { SpdgUserService } from '@spdg/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { take } from 'rxjs';
import { captureParams } from 'src/app/utility/child-tab-close';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false,
})
export class LoginComponent implements OnInit {
    private readonly rdsToastService = inject(RdsToastService);
    public error = false;
    public errorMessage = '';
    public initLoading = true;
    public loading = true;

    constructor(
        private readonly oAuthService: OAuthService,
        private readonly activatedRoute: ActivatedRoute,
        private readonly userService: SpdgUserService
    ) {}

    public loginRequest() {
        this.userService.loginCommandRequest();
    }

    ngOnInit(): void {
        this.activatedRoute.data.pipe(take(1)).subscribe({
            next: (data) => {
                const direct = data['direct'] as boolean;

                captureParams(this.activatedRoute.snapshot);

                const urlRedirect =
                    this.activatedRoute.snapshot.queryParamMap.get(
                        'redirectTo'
                    );
                if (urlRedirect) {
                    sessionStorage.setItem('postLoginRedirectUrl', urlRedirect);
                }

                if (
                    globalThis.location.search.startsWith('?code=') ||
                    this.oAuthService.hasValidAccessToken() ||
                    direct
                ) {
                    this.userService.loginCommandRequest();
                } else {
                    this.initLoading = false;
                    this.loading = false;
                }

                if (sessionStorage.getItem('justExpired') === 'true') {
                    this.rdsToastService.error(
                        'Session expired',
                        'Please log in again'
                    );
                    sessionStorage.setItem('justExpired', 'false');
                }
            },
        });
    }

    private handleError(text: string) {
        this.error = true;
        this.errorMessage = text;
    }
}
